const green = {
    100: 'rgb(179, 230, 209)',
    200: 'rgb(148, 219, 191)',
    300: 'rgb(117, 209, 172)',
    400: 'rgb(87, 199, 154)',
    500: 'rgb(61, 184, 135)',
    600: 'rgb(51, 153, 112)',
    700: 'rgb(41, 122, 90)',
    800: 'rgb(31, 92, 67)',
};
export default green;
